// extracted by mini-css-extract-plugin
export default {"table":"empty-lines_table__9rOkN","th":"empty-lines_th__N1fKK","emptyCell":"empty-lines_emptyCell__nJLsC"};